import React from 'react';
import { SCLA_PROGRAM_SUMMARY } from '../../copy/sclaProgramCopy';
import SclaHighlights from './SclaHighlights';
import styles from './SclaHome.module.scss';

export default function SclaProgramIntro() {
  return (
    <section className={`${styles.card} ${styles.intro}`}>
      <h2 className="txt-heading">What is Summer Coding Leadership Academy (SCLA)</h2>
      <p className="txt-body">{SCLA_PROGRAM_SUMMARY}</p>

      <h3 className={styles.highlightsTitle}>What you&apos;ll do and learn</h3>
      <SclaHighlights />
    </section>
  );
}
